import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  getProductGroupsLookups,
  getProductGroupsDatatable,
  createProductGroup,
  editProductGroup,
  getProductGroupById,
  setProductsToProductGroup,
  getProductGroupByIdWithProducts,
} from './thunks';
import { ProductGroupsState } from './types';

export const name = 'productGroups';

export const getProductGroupsLookupsAsync = createAsyncThunk(
  name + '/getProductGroupsLookups',
  getProductGroupsLookups
);

export const getProductGroupsDatatableAsync = createAsyncThunk(
  name + '/getProductGroupsDatatable',
  getProductGroupsDatatable
);

export const createProductGroupAsync = createAsyncThunk(
  name + '/createProductGroup',
  createProductGroup
);

export const editProductGroupAsync = createAsyncThunk(
  name + '/editProductGroup',
  editProductGroup
);

export const getProductGroupByIdAsync = createAsyncThunk(
  name + '/getProductGroupById',
  getProductGroupById
);

export const getProductGroupByIdWithProductsAsync = createAsyncThunk(
  name + '/getProductGroupByIdWithProducts',
  getProductGroupByIdWithProducts
);

export const setProductsToProductGroupAsync = createAsyncThunk(
  name + '/setProductsToProductGroup',
  setProductsToProductGroup
);

const initialState: ProductGroupsState = {
  productGroupsLookups: {
    data: [],
    status: 'idle',
  },
  productGroupsDatatable: {
    data: null,
    status: 'idle',
  },
  createProductGroup: {
    data: null,
    status: 'idle',
  },
  editProductGroup: {
    status: 'idle',
  },
  productGroupById: {
    data: null,
    status: 'idle',
  },
  productGroupByIdWithProducts: {
    data: null,
    status: 'idle',
  },
  setProductsToProductGroup: {
    status: 'idle',
  },
};

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearProductGroup: (state) => {
      state.productGroupById = {
        data: null,
        status: 'idle',
      };
    },
    clearProductGroupWithProducts: (state) => {
      state.productGroupByIdWithProducts = {
        data: null,
        status: 'idle',
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProductGroupsLookupsAsync.pending, (state) => {
        state.productGroupsLookups.status = 'loading';
      })
      .addCase(getProductGroupsLookupsAsync.fulfilled, (state, action) => {
        state.productGroupsLookups = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getProductGroupsLookupsAsync.rejected, (state) => {
        state.productGroupsLookups.status = 'failed';
      })
      .addCase(getProductGroupsDatatableAsync.pending, (state) => {
        state.productGroupsDatatable.status = 'loading';
      })
      .addCase(getProductGroupsDatatableAsync.fulfilled, (state, action) => {
        state.productGroupsDatatable = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getProductGroupsDatatableAsync.rejected, (state) => {
        state.productGroupsDatatable.status = 'failed';
      })
      .addCase(createProductGroupAsync.pending, (state) => {
        state.createProductGroup.status = 'loading';
      })
      .addCase(createProductGroupAsync.fulfilled, (state, action) => {
        state.createProductGroup = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(createProductGroupAsync.rejected, (state) => {
        state.createProductGroup.status = 'failed';
      })
      .addCase(editProductGroupAsync.pending, (state) => {
        state.editProductGroup.status = 'loading';
      })
      .addCase(editProductGroupAsync.fulfilled, (state) => {
        state.editProductGroup = {
          status: 'idle',
        };
      })
      .addCase(editProductGroupAsync.rejected, (state) => {
        state.editProductGroup.status = 'failed';
      })
      .addCase(getProductGroupByIdAsync.pending, (state) => {
        state.productGroupById.status = 'loading';
      })
      .addCase(getProductGroupByIdAsync.fulfilled, (state, action) => {
        state.productGroupById = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getProductGroupByIdAsync.rejected, (state) => {
        state.productGroupById.status = 'failed';
      })
      .addCase(getProductGroupByIdWithProductsAsync.pending, (state) => {
        state.productGroupByIdWithProducts.status = 'loading';
      })
      .addCase(
        getProductGroupByIdWithProductsAsync.fulfilled,
        (state, action) => {
          state.productGroupByIdWithProducts = {
            data: action.payload,
            status: 'idle',
          };
        }
      )
      .addCase(getProductGroupByIdWithProductsAsync.rejected, (state) => {
        state.productGroupByIdWithProducts.status = 'failed';
      })
      .addCase(setProductsToProductGroupAsync.pending, (state) => {
        state.setProductsToProductGroup.status = 'loading';
      })
      .addCase(setProductsToProductGroupAsync.fulfilled, (state) => {
        state.setProductsToProductGroup = {
          status: 'idle',
        };
      })
      .addCase(setProductsToProductGroupAsync.rejected, (state) => {
        state.setProductsToProductGroup.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
